import { useQuery } from '@sequencehq/api'
import {
  Dashboardv99990101Api,
  dashboardv99990101Client
} from '@sequencehq/api/dashboard/v99990101'

type TriggerType = Dashboardv99990101Api.Automations.TriggerType

type Conflict = {
  automationId: string
  automationName: string
  versionId: string
}

type Result = {
  isLoading: boolean
  conflict: Conflict | null
}

export const useDuplicateActiveTriggerCheck = (params: {
  automationId: string | undefined
  triggerType: TriggerType | undefined
}): Result => {
  const { automationId, triggerType } = params

  const activeVersionsQuery = useQuery(
    dashboardv99990101Client.getAllAutomationVersions,
    triggerType ? { triggerType, active: true } : undefined,
    { enabled: !!triggerType }
  )

  const conflictingVersion = activeVersionsQuery.data?.items.find(
    version => version.automationId !== automationId
  )

  const conflictingAutomationQuery = useQuery(
    dashboardv99990101Client.getAutomation,
    conflictingVersion ? { id: conflictingVersion.automationId } : undefined,
    { enabled: !!conflictingVersion }
  )

  if (!triggerType) {
    return { isLoading: false, conflict: null }
  }

  if (activeVersionsQuery.isLoading) {
    return { isLoading: true, conflict: null }
  }

  if (!conflictingVersion) {
    return { isLoading: false, conflict: null }
  }

  if (conflictingAutomationQuery.isLoading) {
    return { isLoading: true, conflict: null }
  }

  return {
    isLoading: false,
    conflict: {
      automationId: conflictingVersion.automationId,
      automationName: conflictingAutomationQuery.data?.name ?? '',
      versionId: conflictingVersion.id
    }
  }
}
